module.exports = __webpack_public_path__ + "static/media/logo-default.a76c25d2.jpg";